// extracted by mini-css-extract-plugin
export default {"container":"rVyax","item":"dGhRQ","icon":"tjRvi"};